<template>
  <ResearchGalleryPage
    page-title="研究生教育"
    section-label="教育与人才"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuYanjiushengjiaoyu',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: '/lanhu_jiaoyuyurencai',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '研究生教育概况',
          kicker: '1978-2018',
          columns: 1,
          description: [
            '中国社会科学院研究生院新闻学与传播学系（简称“新闻系”）成立于 1978 年 6 月。根据当时中央领导同志的意见，组建新闻系的目的在于为中央主要新闻单位培养高层次的新闻人才，以解决新闻干部青黄不接的问题。',
            '新闻系最初由人民日报社、新华社和中国社会科学院 3 家共同筹办，其后中国日报社也参与了联合办学。2001 年，新闻系开始由中国社会科学院新闻与传播研究所单独管理。',
            '40 年来，新闻系为中国新闻业培养了大批高素质的领军人才，被誉为中国新闻界的“黄埔军校”。截至 2018 年 7 月，新闻系培养博士研究生 63 人，硕士研究生 797 人。同时，还先后开办了多期在职硕士生课程班，培养学生近千人。目前，该系有博士生导师 7 人，硕士生导师 21 人。'
          ],
          items: []
        },
        {
          title: '第一届研究生毕业合影',
          kicker: '1981',
          columns: 1,
          description: [
            '1981 年 7 月，中国社会科学院研究生院新闻系第一届研究生毕业合影。',
            '前排左起：陈国少、张争、贾德昌、张达、苏金琥、张宗厚、明安香、王奔洲、谢冰岩、戴邦、谭立、赵颖楠、熊蕾、李彩英、孙晓阳、夏晓林、高志华、邢平安、原卿友、赵相如、李德民、张铭清、刘力群、陈祖声。',
            '中排左起：许焕隆、王凤超、张一凡、岳颂东、郭亚夫、陈耕涛、吴鸿业、杨润时、李长群、关群、杨良化、朱习华、易凯、秦新民、张木友、江建国、李松晨、鲍广仁、陈力丹、闵大洪、李祖兴、艾丰、罗茂城、张书政。',
            '后排左起：郭敏功、熊昌义、谢骏、刘国胜、魏亚南、王武录、段心强、李安达、姚赣南、舒小骅、向纯武、窦其文、谷安林、虞绍荣、吴兴华、孙旭培、于宁、张克迅、高原、赵庆华、王平兴、张宝林、黄文福、莫新元、徐东明、邹大毅、魏国强、赵希龙。',
            '说明：入学 86 人，毕业 83 人，照像 73 人。戴松成、洪天国、孟晓云、张岩、朱维群（以上新闻业务专业）等 10 人缺席。'
          ],
          items: [
            {
              src: require('./assets/html/graduate-1981-graduates.jpg'),
              caption: '1981 年 7 月，中国社会科学院研究生院新闻系第一届研究生毕业合影'
            }
          ]
        },
        {
          title: '教学与讲座',
          kicker: '1980s-2018',
          columns: 2,
          items: [
            {
              src: require('./assets/html/graduate-gxifen-lecture.jpg'),
              caption: '甘惜分教授应邀给新闻系学生授课'
            },
            {
              src: require('./assets/html/graduate-zhongpeizhang-lecture.jpg'),
              caption: '钟沛璋老师给新闻系学生授课'
            },
            {
              src: require('./assets/html/graduate-2007-mazaixin.jpg'),
              caption: '2007 年 9 月，新闻学与传播学系系友、加拿大大华商报社社长马在新给研究生作讲座'
            },
            {
              src: require('./assets/html/graduate-2018-songxiaowei.jpg'),
              caption: '2018 年 6 月，宋小卫研究员为新闻学与传播学系研究生授课'
            },
            {
              src: require('./assets/html/graduate-2018-chenlidan.jpg'),
              caption: '2018 年 9 月，陈力丹教授应邀为新闻学与传播学系研究生作讲座',
              wide: true
            }
          ]
        },
        {
          title: '学生与系友活动',
          kicker: '1987-2017',
          columns: 2,
          items: [
            {
              src: require('./assets/html/graduate-1987-xiangshan.jpg'),
              caption: '1987 年 7 月，新闻系 84 级研究生在北京香山留影（从左至右：文璐、王光明、廖晓英、朱晓明、娄小壮、林浩、宋小卫、上官卫国、张毅、唐绪军）'
            },
            {
              src: require('./assets/html/graduate-8485-yuanmingyuan.jpg'),
              caption: '新闻系 84、85 级理论班部分同学与班主任老师朱向霞在圆明园合影（从左至右：赵宁、杨秀武、？、高永志、廖晓英、刘雪松、朱向霞、朱晓明、娄小壮、孙永平、林浩、王红明、张西明）'
            },
            {
              src: require('./assets/html/graduate-2013-course-class.jpg'),
              caption: '2013 年 3 月，中国外文局国际传播与实践方向研究生课程班学员与新闻学与传播学系硕士生导师交流座谈会在新闻与传播研究所召开'
            },
            {
              src: require('./assets/html/graduate-2017-new-students.jpg'),
              caption: '2017 年 9 月，新闻学与传播学系领导、部分导师与该系 2017 级新生合影'
            }
          ]
        }
      ]
    };
  }
};
</script>
